module.exports = __webpack_public_path__ + "img/brand-icon1.c69e36f6.png";